// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Frame, Heading, Page, Spinner } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import queryString from 'query-string';

// import { routes } from 'src/routes';
import * as installAction from 'actions/install-actions';
import { Empty } from 'src/components/views/common/empty';
import { saveHost } from 'src/integrations/shopify-app-bridge/app';
import { startSABLoading, stopSABLoading } from 'src/integrations/shopify-app-bridge/loading';
import { inIframe, buildRedirectUrl } from 'src/helpers';

import type { Props, State } from './finalize.type';

class Finalize extends Component<Props, State> {
  state = {
    tenantId: '',
    messageError: ''
  };

  componentDidMount() {
    const queries = queryString.parse(this.props.location.search);

    // Save hostname for Shopify App Bridge
    const { host } = queries;
    saveHost(host);

    // Only call API if the app is loaded in iframe
    if (inIframe() || process.env.NODE_ENV === 'development') {
      this.installApp();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { code, shop, installationError = '' } = nextProps;

    if (code && code === 'installed') {
      // window.top.location.href = 'https://' + shop + '/admin/apps/' + config.app.apiKey;
      const redirectUrl = buildRedirectUrl(shop);
      window.top.location.href = redirectUrl;
    } else if (!_.isEmpty(installationError)) {
      const queries = queryString.parse(this.props.location.search);
      const tenantId = shop ? shop : _.get(queries, 'shop', '');

      // Set text for displaying Error page
      this.setState({
        tenantId,
        messageHeading: "Oops! It seems we're having a small issue connecting.",
        messageError: 'No worries! Just refresh the page, and you should be good to go.'
      });
    }

    if (nextProps.loading === true && this.props.loading === false) {
      startSABLoading();
    }

    if (nextProps.loading === false && this.props.loading === true) {
      stopSABLoading();
    }
  }

  render() {
    const { i18n } = this.props;
    const { messageHeading, messageError, tenantId } = this.state;
    const redirectUrl = buildRedirectUrl(tenantId);

    return (
      <Frame>
        {messageError ? (
          <Empty
            heading={messageHeading}
            message={messageError}
            redirectUrl={redirectUrl}
            //routePath={routes.dashboard.view()}
          />
        ) : (
          <Page>
            <div className="BC-AppLoadingPage">
              <Spinner
                accessibilityLabel={i18n.translate('AdminHTML.InstallationV2.Finalize.title')}
                size="large"
              />
              <Heading>{i18n.translate('AdminHTML.InstallationV2.Finalize.title')}</Heading>
              <p>{i18n.translate('AdminHTML.InstallationV2.Finalize.description1')}</p>
            </div>
          </Page>
        )}
      </Frame>
    );
  }

  installApp = () => {
    const queries = queryString.parse(this.props.location.search);

    this.props.installApp(queries);
  };
}

const mapStateToProps = state => ({
  loading: state.install.loading,
  code: state.install.code,
  message: state.install.message,
  shop: state.install.shop,
  installationError: state.install.installationError
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  // Install app
  installApp: queries => dispatch(installAction.installApp(queries, ownProps.i18n))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Finalize));
